import './index.scss'
import Swiper from 'swiper/js/swiper.min.js'

var swiper = new Swiper(".login-swiper .mySwiper", {
  autoHeight: true, //高度随内容变化
  allowTouchMove: false,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  on: {
    init: function(swiper){
      $('.login-tab div').eq(this.activeIndex).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.login-tab div').eq(this.activeIndex).addClass('active').siblings().removeClass('active')
    },
    resize: function(){
      let that = this
      setTimeout(function(){
        that.update(); //窗口变化时，更新Swiper的一些属性，如宽高等
      },500)
    }, 
  },
});

$('.login-tab div').on('click',function(){
  let index = $(this).index()
  swiper.slideTo(index)
})

$('.mob-phone-register-btn').on('click',function(){
  swiper.slideTo(1)
})
$('.mob-email-register-btn').on('click',function(){
  swiper.slideTo(0)
})


// $('.form-item .btn.send-code').on('click',function(){
//   let _this = this
//   let number = 60
//   $(_this).removeClass('send-code')
//   let timer = setInterval(function(){
//     if(number <= 1){
//       clearInterval(timer)
//       $(_this).addClass('send-code')
//     }else{
//       number = number - 1
//       $(_this).find('.num span').html(number)
//     }
//   },1000)
// })
